import { atom } from 'jotai'

export const captchaErrorAtom = atom<Error | null>(null)
